// extracted by mini-css-extract-plugin
export default {"root":"RedirectBlock_root__dnYeC","root__button":"RedirectBlock_root__button__egqNo"};